import { Typography } from '@mui/material';
import { NotificationDialog } from './NotificationDialog';
import { FLEXIBLE_REPORTING_TRIAL_TEXT } from '../domain/text/flexible-reporting-trial-text';

const DIALOG_KEY = 'flexible-reporting-7/2';

export const FlexibleReportingDialog = () => {
  return (
    <NotificationDialog notificationKey={DIALOG_KEY}>
      <Typography>{FLEXIBLE_REPORTING_TRIAL_TEXT}</Typography>
    </NotificationDialog>
  );
};
